import { Box, Tab, Tabs } from "@mui/material";
import React from "react";

// Define types for props
interface TabData {
  label: string;
  content: React.ReactNode;
}

interface TabsMAIQProps {
  tabs: TabData[];
  contentStyle?: React.CSSProperties | any;
}

const TabsMAIQ: React.FC<TabsMAIQProps> = ({ tabs, contentStyle }) => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  // Ensure value is within bounds
  const safeValue = tabs.length > 0 ? Math.min(value, tabs.length - 1) : 0;
  const currentTab = tabs[safeValue];

  return (
    <Box sx={{ 
      width: "100%", 
      // bgcolor: "background.paper",
      height: "100%", // Adjust height to account for header, breadcrumbs, and tabs
      display: "flex",
      flexDirection: "column"
    }}>
      {tabs.length > 0 && (
        <Tabs 
          value={safeValue} 
          onChange={handleChange} 
          variant="fullWidth"
          sx={{ 
            flexShrink: 0, // Prevent tabs from shrinking
            borderBottom: 1,
            borderColor: 'divider'
          }}
        >
          {tabs.map((tab, index) => (
            <Tab key={index} label={tab.label} />
          ))}
        </Tabs>
      )}
      <Box sx={{ 
        p: 3, 
        flex: 1, // Take remaining space
        overflowY: "auto", // Make content scrollable
        overflowX: "hidden", // Prevent horizontal scroll
        ...(contentStyle || {})
      }}>
        {currentTab ? currentTab.content : null}
      </Box>
    </Box>
  );
};

export default TabsMAIQ;
